<template>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1100"
      pdf-content-width="480px"
      :filename="fileName"
      :pdf-quality="3"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      ref="qrCodePdf"
      :html-to-pdf-options="htmlToPdfOptions"
      @hasDownloaded="hasDownloaded()"
    >
      <template slot="pdf-content">
        <div class="qr-container html2pdf__page-break">

            <div  v-bind:key="'pdf-qr-only'+variant.id" v-for="variant in productData.variants" style="margin-bottom: 15px;">
                <qrcode-vue :value="qrCodeValue" size="150" />
                <div class="price">
                    {{variant.size ? variant.size + ': ': ''}}${{ (variant.sale_price && (variant.sale_price < variant.price)) ? variant.sale_price.toFixed(2) : variant.price >= 0 ? variant.price.toFixed(2) : 'N/A' }}
                </div>
            </div>
        </div>
      </template>
    </vue-html2pdf>
  </template>
  <script>
  import QrcodeVue from 'qrcode.vue'
  import VueHtml2pdf from 'vue-html2pdf'
  export default {
    props: ['productData', 'qrCodeValue'],
    components: {
      QrcodeVue,
      VueHtml2pdf
    },
    computed: {
      htmlToPdfOptions() {
        return {
          filename: this.fileName,
          // image: { type: 'png', quality: 1 },
          image: { type: 'jpeg', quality: 0.55 },
          html2canvas: {
            scrollX: 0,
            scrollY: 0,
            useCORS: true,
            dpi: 192,
            scale: 2,
            letterRendering: true
          }
        }
      },
      fileName() {
        return `product-card.pdf`
      }
    },
    methods: {
      hasDownloaded() {
        this.$emit('hasDownloaded')
      },
      generatePdf() {
        this.$refs.qrCodePdf.generatePdf()
      },
      getPrice(val) {
        let allPrices = []
        if (!val.variants || val.variants.length === 0) {
          return ''
        }
        val.variants.map((variant) => {
          allPrices.push(variant.price)
        })
        let value = Math.min(...allPrices)
        return '$ ' + value
      }
    }
  }
  </script>
  <style scoped lang="scss">
  .qr-container {
    margin-left: 22px;
    margin-top: 40px;
    display: inline-block;
    position: relative;
    text-align: center;
  
    .price {
      height: 50px;
      font-size: 30px;
      margin-top: 12px;
    }
  }
  </style>
  